import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import {
	Component,
	Input,
	ViewChild,
	ViewChildren,
	ChangeDetectionStrategy,
} from "@angular/core"
import { OptionsList } from "@app/definitions/opts"
import {
	ConfigDefinitions,
	FinResource,
	Followup,
	InvoiceLine,
	AutoCompleteKeyUpObj,
	FinResourcePeriods,
	FinResourceType,
	yes_no_opts,
} from "@app/definitions/types"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { DatePickerComponent } from "@app/utils/date-picker/date-picker.component"
import * as moment from "moment"
import { WysiwygComponent } from "../utils/wysiwyg/wysiwyg.component"
import { Modalable } from "@app/Modalable"
import {
	dateDisplay,
	defaultEmptyString,
	defaultZero,
	getChecked,
	getCheckedIds,
	sumByProp,
} from "@app/helpers"
import { COMMON_IMPORTS } from "../common-imports"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { NgTemplateOutlet } from "@angular/common"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { FinNumberPipe } from "@app/utils/finNumber.pipe"
import { ExternalInvoiceComponent } from "@app/external-invoice/external-invoice.component"
import { InArrayPipe } from "@app/utils/in-array.pipe"
import { AutocompleteMultiComponent } from "@app/gen-inputs/autocomplete-multi/autocomplete-multi.component"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import {
	BtnExtComponent,
	CancelBtnComponent,
	SpinOrContent,
} from "@app/utils/utils.component"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { TaExpandsComponent } from "@app/utils/ta-expands/ta-expands.component"
import { PreviewFinresourceComponent } from "@app/preview-finresource/preview-finresource.component"
import { PromptInputFieldComponent } from "@app/prompt-input-field/prompt-input-field.component"
import { GetNextIdComponent } from "@app/get-next-id.component"
import { GenTableAddItemComponent } from "@app/gen-table-add-item/gen-table-add-item.component"
import { GetHeadtureRowComponent } from "@app/get-headture-row.component"
import { ConfirmComponent } from "@app/confirm/confirm.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"

function doctypeDefault(value: any) {
	return value || "invoice"
}
function defaultNo(value: any) {
	return value || "no"
}

@Component({
	selector: "app-add-invoice",
	imports: [
		COMMON_IMPORTS,
		ModalWrapComponent,
		GenButtonGroupComponent,
		LangValPipe,
		FinNumberPipe,
		ExternalInvoiceComponent,
		InArrayPipe,
		GenInputComponent,
		AutocompleteMultiComponent,
		DatePickerComponent,
		WysiwygComponent,
		DateFormatPipe,
		SpinOrContent,
		GenSelectComponent,
		GenAutocompleteComponent,
		TaExpandsComponent,
		CancelBtnComponent,
		BtnExtComponent,
		PreviewFinresourceComponent,
		PromptInputFieldComponent,
		GetNextIdComponent,
		GenTableAddItemComponent,
		GetHeadtureRowComponent,
		ConfirmComponent,
		GenTableDisplayComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./add-invoice.component.html",
})
export class AddInvoiceComponent extends Modalable {
	modalProps: any = null
	previewObj: any = null

	lastMonth: string = moment
		.utc()
		.subtract(1, "month")
		.format("MMM")
		.toLowerCase() // name of last month to display

	@Input({ transform: doctypeDefault }) doctype: FinResourceType = "invoice" //invoice, proforma, admininvoice, receipt(like invoice) (no payment_details,instead of proforma_id - justinvoice_id), justinvoice(like proforma) selfinvocie
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	vat: number = 0
	show_payment_details: string = "no"
	showPaymentDetailsButton: string = "no"
	bank_account_text: string = ""
	no_vat: string = "no"
	curLine: InvoiceLine | null = null
	@ViewChild("payment_detailsWysiwyg") payment_detailsWysiwyg!: WysiwygComponent
	@ViewChild("proformaTotal") proformaTotal!: GenInputComponent
	@ViewChildren(GenInputComponent) genInputs
	@ViewChildren(GenAutocompleteComponent) genAutocompletes
	@ViewChild("fromDate") fromDate!: DatePickerComponent
	@ViewChild("toDate") toDate!: DatePickerComponent
	@ViewChild("firstField") firstField!: GenInputComponent

	periodInputs: any[] = [
		"this_month",
		"month_before",
		"this_week",
		"today",
		"date_range",
	].map((it) => ({ name: it, value: it }))
	// currentPeriod: FinResourcePeriods = "month_before";
	currentPeriod: string = "month_before" //FinResourcePeriods

	OptionsList = OptionsList
	finresourceDocType_opts = OptionsList.finresourceDocType_opts
	finresourceDocType_display: any[] = []

	finresourceObj: FinResource = new FinResource()

	@Input() inputRow: any = null //passes the recepient of the invoice (user/payor etc.). if used, must have id,name
	@Input({ transform: defaultZero }) resourceId: number = 0
	@Input({ transform: defaultEmptyString }) resource: string = "" //TO WHOM this invoice/proforma/etc is being created (eg. patient,payor,contact,user etc)
	proformas: any[] = []
	justinvoices: any[] = []
	receipts: any[] = []
	bankaccounts: any[] = []
	@Input({ transform: defaultEmptyString }) description: string = ""
	email_details: string = ""
	@Input({ transform: defaultEmptyString }) paid_by: string = ""
	@Input({ transform: defaultNo }) is_withholding_tax: string = "no"
	@Input({ transform: defaultZero }) withholding_tax_percent: number = 0
	@Input({ transform: defaultEmptyString }) for: string = ""
	invoice_per_followup: boolean = false
	followups: any[] = []
	futureFuses: any[] = []
	credit: number = 0
	followupsLoading: boolean = false
	followupsAndCreditSum: number = 0
	futureFusesSum: number = 0
	followupsAllChecked: boolean = true
	futureFusesAllChecked: boolean = true

	isNgo: boolean = false
	isWithholdingTax: boolean = false
	is_add_assoc: boolean = false
	show_prices_withoutvat_in_finresource: boolean = false
	payment_for_future_meetings: boolean = false
	payment_for_future_meetings_clicked: boolean = false
	isGettingFutureFuses: boolean = false
	isFinanciallyNew: boolean | null = null

	defaultValues: any = {}

	detailsServerCall: any
	lastDoctypeServerCall: any
	has_id_number: boolean = false
	needsIta: boolean = false

	isCreditChecked = true
	hasCurrentPlus: boolean = false

	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		invoice: {
			paid_by: {},
			description: { not_empty: null },
			// sum: {'not_zero': null},
		},
		proforma: {
			for: { not_empty: null },
			description: { not_empty: null },
			attached_summary_text: { not_empty: null },
			total: { not_empty: null, not_zero: null },
		},
		admininvoice: {
			paid_by: { not_empty: null },
		},
		justinvoice: {
			paid_by: {},
			description: { not_empty: null },
			total: { not_empty: null, not_zero: null },
		},
		receipt: {
			paid_by: {},
			description: { not_empty: null },
		},
		selfinvoice: {
			paid_by: {},
			description: { not_empty: null },
		},
	}

	message: string = ""

	reset() {
		//reset values before opening the modal

		this.finresourceObj = new FinResource()
		this.description = ""
		this.email_details = ""
		this.paid_by = ""
		this.has_id_number = false
		this.is_withholding_tax = "no"
		this.withholding_tax_percent = 0
		this.for = ""
		this.doctype = "invoice"
		this.defaultValues = {}
		this.inputRow = null
		this.proformas = []
		this.justinvoices = []
		this.receipts = []
		this.errors = {}
		this.isFormSubmittable = false
		this.currentPeriod = "month_before"
		this.invoice_per_followup = false
		this.followups = []
		this.futureFuses = []
		this.credit = 0
		this.futureFusesSum = 0
		this.followupsLoading = false
		this.followupsAndCreditSum = 0
		this.followupsAllChecked = true
		this.futureFusesAllChecked = true
		this.payment_for_future_meetings = false
		this.payment_for_future_meetings_clicked = false
		this.isGettingFutureFuses = false

		this.postReset()
	}
	postReset() {
		let cliniqData = this.store.cc()
		this.isNgo =
			cliniqData?.tax_account_type == "ngo" ||
			cliniqData?.tax_account_type == "op"
		// this.isNgo=false;
		this.finresourceDocType_display = [
			...this.finresourceDocType_opts.map((it) => ({ ...it })),
		]
		this.has_id_number = cliniqData?.id_on_invoice === "yes"

		if (this.isNgo) {
			this.doctype = "receipt"
			this.finresourceDocType_display = this.finresourceDocType_display.filter(
				(it) => it.value != "invoice" && it.value != "justinvoice"
			)
		}

		this.is_add_assoc =
			this.permsService.owner_has_users &&
			!cliniqData.only_therapist_id &&
			cliniqData.show_therapist != "no"

		this.show_prices_withoutvat_in_finresource =
			cliniqData.prices_withoutvat_in_finresource == "yes"
	}
	async runIsFinanciallyNew() {
		if (this.resource == "patient" && this.isFinanciallyNew === null) {
			this.isFinanciallyNew = await this.apiService.post("is_financially_new", {
				patient_id: this.resourceId,
			})
		}
	}

	fuzzyKeyUp(obj: AutoCompleteKeyUpObj, line: any, fieldName: string) {
		if (!obj.isIdenticalToPreviousValue) {
			line[fieldName] = 0
			this.validateEntireForm()
		}
	}
	ngOnInit() {
		this.postReset()
		this.initLoad()
	}

	handleUnsubscribe() {
		this.detailsServerCall?.unsubscribe()
		this.lastDoctypeServerCall?.unsubscribe()
	}

	async initLoad() {
		//when called to open
		this.handleUnsubscribe()
		let cliniqData = this.store.cc()

		if (cliniqData?.is_selfinvoice != "yes" || this.resource != "contact") {
			this.finresourceDocType_display = this.finresourceDocType_display.filter(
				(it) => it.value != "selfinvoice"
			)
		}

		if (cliniqData?.show_manual_charge != "yes" || this.resource == "contact") {
			// TODO remove the "no"
			this.finresourceDocType_display = this.finresourceDocType_display.filter(
				(it) => it.value != "external_invoice"
			)
		}

		if (
			this.doctype === "proforma" &&
			!this.finresourceObj.attached_summary_text
		) {
			this.finresourceObj.attached_summary_text =
				this.lang.getVal("attached_summary")
		}

		const invoice_per_followup_doctypes = ["invoice", "proforma", "justinvoice"]
		if (this.isNgo) {
			invoice_per_followup_doctypes.push("receipt")
		}
		this.invoice_per_followup =
			cliniqData.invoice_per_followup == "yes" &&
			this.resourceHasPaymentDetails() &&
			invoice_per_followup_doctypes.includes(this.doctype)

		const payment_for_future_meetings_types = [
			"invoice",
			"justinvoice",
			"receipt",
			"proforma",
		]
		if (
			this.invoice_per_followup &&
			cliniqData.payment_for_future_meetings == "yes" &&
			payment_for_future_meetings_types.includes(this.doctype)
		) {
			//this.resource!="patient" &&
			this.payment_for_future_meetings = true
		}

		this.vat = cliniqData.vat
		this.show_payment_details = cliniqData.show_payment_details
		this.showPaymentDetailsButton = cliniqData.show_payment_details
		this.bank_account_text = cliniqData.bank_account_text
		this.no_vat = cliniqData.withoutvat
		this.finresourceObj.withoutvat = cliniqData.withoutvat

		//has input row (like payor)
		//override with inputRow
		//doesn't have input row

		if (this.inputRow) {
			this.description = this.description
				? this.description
				: this.inputRow.name

			this.paid_by = this.inputRow.name
			this.for = this.inputRow.name
			this.email_details = ""
			this.resourceId = this.inputRow.id
			this.is_withholding_tax = this.inputRow.is_withholding_tax
			this.withholding_tax_percent =
				this.inputRow?.withholding_tax_percent || this.withholding_tax_percent
		} //focus
		if (this.defaultValues.description === undefined) {
			this.defaultValues = {
				description: this.description,
				paid_by: this.paid_by,
				is_withholding_tax: this.is_withholding_tax,
				withholding_tax_percent: this.withholding_tax_percent,
				for: this.for,
				emailDetails: this.email_details,
			}
		}
		if (
			["proforma", "justinvoice"].includes(this.doctype) &&
			this.bank_account_text
		) {
			this.finresourceObj.remarks =
				this.finresourceObj.remarks +
				this.lang.getVal("account_for_deposit") +
				" " +
				this.bank_account_text
		}

		this.finresourceObj.paid_by = this.paid_by
		this.finresourceObj.is_withholding_tax = this.is_withholding_tax
		this.finresourceObj.withholding_tax_percent = this.withholding_tax_percent
		this.finresourceObj.for = this.for
		this.finresourceObj[this.resource + "_id"] = this.resourceId
		this.finresourceObj.description = this.description
		this.finresourceObj.email_details = this.email_details
		this.finresourceObj.resource = this.resource
		if (!this.finresourceObj.from_date) {
			this.finresourceObj.from_date = this.store.getDateStr(false, true)
		}
		if (!this.finresourceObj.to_date) {
			this.finresourceObj.to_date = this.store.getDateStr(true, true)
		}
		this.finresourceObj.total_lm_debt = 0
		this.finresourceObj.total_lm_prices = 0
		this.finresourceObj.total_until_lm_debt = 0
		this.finresourceObj.total_total_debt = 0

		this.runIsFinanciallyNew()

		if (this.resource == "patient") {
			const patient = this.store.searchSiteDataItem(
				this.finresourceObj.patient_id,
				["patients"]
			)
			this.finresourceObj.id_number =
				patient?.id_number?.replace(/\D/g, "") || ""

			const it = this.finresourceDocType_display.find(
				(it) => it.value == "proforma"
			)
			if (it) {
				it.lang = this.lang.getVal("proforma_to_patient")
			}
		}
		if (["payor", "contact"].includes(this.resource)) {
			const person = this.store.searchSiteDataItem(
				this.finresourceObj[`${this.resource}_id`],
				[`${this.resource}s`]
			)
			this.finresourceObj.bn_number =
				person?.bn_number?.replace(/\D/g, "") || ""
		}

		this.hasCurrentPlus = false
		console.log(this.doctype, this.resource)

		if (
			["justinvoice", "proforma"].includes(this.doctype) &&
			["payor", "contact"].includes(this.resource)
		) {
			console.log(
				this.store.searchSiteDataItem(this.resourceId, [`${this.resource}s`])
			)

			this.hasCurrentPlus =
				this.store.searchSiteDataItem(this.resourceId, [`${this.resource}s`])
					?.is_current_plus === "yes"
		}
		console.log(this.hasCurrentPlus)

		if (["invoice", "receipt", "justinvoice"].includes(this.doctype)) {
			let sendObj: any = {
				filterField: this.resource + "_id",
				filterFieldValue: this.resourceId,
			}
			/////////
			const collectionToGetObjs = {
				invoice: ["proformas"],
				receipt: this.isNgo ? ["proformas"] : ["justinvoices"],
				justinvoice: ["receipts", "proformas"],
			}
			for (let collectionToGet of collectionToGetObjs[this.doctype]) {
				const res: any = await this.store.get_gen_items(
					collectionToGet,
					sendObj
				)
				this[collectionToGet] = res[collectionToGet].map((it) => ({
					id: it.id,
					name: `${it.id}-  ${this.lang.getVal("total_of")} ${it.total}`,
					remainder: it.remainder,
					total: it.total,
					followups_data: it?.followups_data,
					description: it?.description_dec,
				}))
			}
			// await this.getBankaccounts();
			this.getBankaccounts()
			if (!this.invoice_per_followup) {
				// this.onDateChange() //
			}
		}

		if (this.doctype == "selfinvoice") {
			this.getBankaccounts()
		}

		if (this.resourceHasPaymentDetails()) {
			if (this.invoice_per_followup) {
				this.getFollowupsAndCreditForFinResource()
			} else if (
				(this.isNgo && this.doctype == "receipt") ||
				["invoice", "justinvoice"].includes(this.doctype)
			) {
				this.onDateChange()
			} else {
				this.addInvoiceLine(true)
			}
		} else {
			this.addInvoiceLine(true)
		}

		if (this.doctype === "admininvoice") {
			this.finresourceObj.description = this.lang.getVal("payment_description")
		}

		this.tryToGetLastDoctype()
	}
	resourceHasPaymentDetails() {
		console.log(this.resource, ["patient", "payor"].includes(this.resource))

		return ["patient", "payor"].includes(this.resource)
	}

	async getFutureFuses() {
		this.payment_for_future_meetings_clicked = true
		this.isGettingFutureFuses = true

		const data = {
			fieldName: this.resource + "_id",
			resourceId: this.resourceId,
		}
		const res = await this.apiService.post("get_future_fuses", data)
		this.isGettingFutureFuses = false

		this.futureFuses = res.fuses
		this.futureFuses.forEach((fus) => {
			if (!fus.price_payor) {
				fus.price_payor = 0
			}
			fus.price =
				this.resource == "payor" ? fus.price_payor : fus.price - fus.price_payor
		})
		this.futureFuses.sort(
			(a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
		)
		const meetingtypes = this.store.getSiteDataTable("meetingtypes")
		const patients = this.store.getSiteDataTable("patients")
		this.futureFuses.forEach((fus) => {
			const meetingtype = meetingtypes.find((it) => it.id == fus.meetingtype_id)
			const patient = patients.find((it) => it.id == fus.patient_id)
			fus.meetingtype_name = meetingtype?.name || ""
			fus.patient_name = patient?.name || ""
			fus.checked = true
		})
		this.calcFutureFuses()
		this.finresourceObj.total =
			Number(this.finresourceObj.total) + this.futureFusesSum
		this.sumAndVatInvoice()
	}
	calcFutureFuses() {
		let sum = 0
		this.futureFuses.forEach((fus) => {
			if (fus.checked) {
				sum += fus.price
			}
		})
		this.futureFusesSum = sum

		this.updateFirstInvoiceLineWithFollowupsAndFutureFuses()
	}
	updateFirstInvoiceLineWithFollowupsAndFutureFuses() {
		if (this.finresourceObj.invoicelines.length) {
			this.getFirstRow().sum = this.futureFusesSum + this.followupsAndCreditSum
			this.numOnly(this.getFirstRow(), "sum", true)
		}
	}

	postGetFollowupsAndCreditForFinResource(res: any) {
		this.followupsLoading = false
		this.credit = Number(res.credit)
		this.followups = res.followups
		this.followups.forEach((followup) => {
			if (!followup.price_payor) {
				followup.price_payor = 0
			}
			followup.price =
				this.resource == "payor"
					? followup.price_payor
					: followup.price - followup.price_payor
			if (this.is_add_assoc) {
				followup.assoc = followup.assocIds
					.map((id) => {
						const obj = this.store.searchSiteDataItem(id, ["sub_users"])
						if (!obj) {
							return ""
						}
						return `${obj.name} ${obj.license_number ? this.lang.getVal("mr") + " " + obj.license_number : ""}`
						//return `${obj.name} (${obj.license_number})`;
					})
					.join(", ")
			}
		})
		this.followups.sort(
			(a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
		)
		const meetingtypes = this.store.getSiteDataTable("meetingtypes")
		const patients = this.store.getSiteDataTable("patients")
		this.followups.forEach((followup) => {
			const meetingtype = meetingtypes.find(
				(it) => it.id == followup.meetingtype_id
			)
			const patient = patients.find((it) => it.id == followup.patient_id)
			followup.meetingtype_name = meetingtype?.name || ""
			if (followup.meetingtype_id == -1) {
				followup.meetingtype_name = this.lang.getVal("former_debt")
			}
			followup.patient_name = patient?.name || ""
			followup.checked = true
		})
		this.updateTotals(res)
		this.calcFollowupsAndCredit()
		this.finresourceObj.total = this.followupsAndCreditSum
		this.addInvoiceLine(true)
		this.sumAndVatInvoice()
	}

	getFollowupsAndCreditForFinResource() {
		const data = {
			fieldName: this.resource + "_id",
			resourceId: this.resourceId,
		}
		this.followupsLoading = true
		this.detailsServerCall = this.apiService.postSubscribe(
			"get_followups_and_credit_for_fin_resource",
			data,
			this.postGetFollowupsAndCreditForFinResource.bind(this)
		)
	}
	calcFollowupsAndCredit() {
		let sum = 0
		this.followups.forEach((followup) => {
			if (followup.checked) {
				sum += followup.price
			}
		})
		if (this.isCreditChecked) {
			sum += -this.credit
		}
		this.followupsAndCreditSum = this.store.only2Digits(sum)

		this.updateFirstInvoiceLineWithFollowupsAndFutureFuses()
	}
	followupCheck(followup: any, checked: boolean) {
		followup.checked = checked
		this.calcFollowupsAndCredit()
	}
	creditCheck(checked: boolean) {
		this.isCreditChecked = checked
		this.calcFollowupsAndCredit()
	}
	futureFusCheck(fus: any, checked: boolean) {
		fus.checked = checked
		this.calcFutureFuses()
	}
	postTryToGetLastDoctype(res: any) {
		// get description and paid by from last document for this person
		// get last document - this.resource,this.resource_id, this.doctype

		if (res.description) {
			this.description = res.description || ""
		} else {
			this.description = this.defaultValues.description
		}

		if (res.attached_summary_text) {
			this.finresourceObj.attached_summary_text = res.attached_summary_text
		} else {
			this.finresourceObj.attached_summary_text =
				this.lang.getVal("attached_summary")
		}
		if (res.email_details) {
			this.email_details = res.email_details || ""
		} else {
			this.email_details = this.defaultValues.email_details
		}
		if (res.paid_by) {
			this.paid_by = res.paid_by || ""
		} else {
			this.paid_by = this.defaultValues.paid_by
		}
		if (res.for) {
			this.for = res.for || ""
		} else {
			this.for = this.defaultValues.for
		}
		this.finresourceObj.paid_by = this.paid_by
		this.finresourceObj.description = this.description
		this.finresourceObj.email_details = this.email_details
		this.finresourceObj.for = this.for
		//	this.finresourceObj.for = res?.for;

		if (res?.current_plus !== undefined) {
			this.finresourceObj.current_plus = res.current_plus
		}

		if (res?.paymentmethod && this.finresourceObj.invoicelines.length) {
			const row = this.getFirstRow()
			row.paymentmethod = res.paymentmethod
			this.onChangePaymentmethod(row)
		}

		this.validateEntireForm()
		if (this.firstField) {
			this.firstField.focus()
		}
	}

	tryToGetLastDoctype() {
		if (["admininvoice", "external_invoice"].includes(this.doctype)) {
			return
		}
		let getDescriptionObj = {
			fieldName: this.resource + "_id",
			id: this.resourceId,
			doctype: this.doctype,
		}
		this.lastDoctypeServerCall = this.apiService.postSubscribe(
			"get_last_finresouce_item_by_person",
			getDescriptionObj,
			this.postTryToGetLastDoctype.bind(this)
		)
	}

	async getBankaccounts() {
		let sendObj = {
			filterField: this.resource + "_id",
			filterFieldValue: this.resourceId,
		}
		const res: any = await this.store.get_gen_items("bankaccounts", sendObj)
		this.bankaccounts = res.bankaccounts
		this.bankaccounts.forEach(
			(row) =>
				(row.name = row.name ? `${row.number} - ${row.name}` : `${row.number}`)
		)
		//this.bankaccounts.forEach(row => row.name = `${row.number} - ${row.name}`);
	}
	postGetResourceByDates(res: any) {
		const lineHeight = ""
		console.log("postGetResourceByDates")

		let totalPaymentDetails: number = 0
		if (this.show_payment_details == "yes") {
			if (
				res["followups_per_" + this.resource] &&
				res["followups_per_" + this.resource].length
			) {
				let html = `<p style="font-size:14px;font-weight: bold;">${this.lang.getVal("payment_details")} ${moment.utc(this.finresourceObj.from_date).format("D.M.Y")} - ${moment.utc(this.finresourceObj.to_date).format("D.M.Y")}</p>`

				if (this.resource == "patient") {
					html += `<table style="width:100%" class="invoice-payment-details"   ><thead>
                <tr style="${lineHeight}" >
                <th >${this.lang.getVal("type")}</th>
                <th>${this.lang.getVal("date")}</th>
                <th >${this.lang.getVal("price")}</th>
                ${this.is_add_assoc ? `<th >${this.lang.getVal("therapist")}</th>` : ""}
                </tr>
                </thead><tbody>`
					res["followups_per_" + this.resource].forEach((followup, index) => {
						if (followup.meetingtype_id == -1) {
							followup.meetingtype_name = this.lang.getVal("former_debt")
						}
						html += `<tr style="${lineHeight}${index % 2 ? "" : "background-color:#F5F5F5;"} "><td>${followup.meetingtype_name}</td><td>${this.store.flipDateOrder(followup.date)}</td><td class="display-number"   >${followup.price}</td>   ${this.is_add_assoc ? `<td>${followup?.assoc}</td>` : ""}  </tr>`
						totalPaymentDetails += +followup.price
					})
				} else if (this.resource == "payor") {
					html += `<table style="width:100%"   >
            <thead>
            <tr style="${lineHeight}" >
                <th ><strong>${this.lang.getVal("name")}</strong></th>
                <th ><strong>${this.lang.getVal("meetingtype")}</strong></th>
                <th ><strong>${this.lang.getVal("price")}</strong></th>
                <th ><strong>${this.lang.getVal("sum")}</strong></th>
                </tr>
                </thead>
                <tbody>`
					res["followups_per_" + this.resource].forEach((followup, index) => {
						html += `<tr style="${lineHeight}${index % 2 ? "" : "background-color:#F5F5F5;"} ">
                    <td>${followup.name}</td>
                    <td>${followup.mtypename}(${followup.count})</td>
                    <td>${followup.price}</td>
                    <td>${followup.sum}</td></tr>`
						totalPaymentDetails += +followup.sum
					})
				}
				html += `</tbody></table>`
				if (this.show_payment_details == "yes") {
					if (this.payment_detailsWysiwyg) {
						console.log(html)

						this.payment_detailsWysiwyg.replaceText(html)
					}
				}
				this.finresourceObj.payment_details = html
			}
		}
		if (totalPaymentDetails != 0) {
		}
		this.finresourceObj.total = totalPaymentDetails
		this.updateTotals(res)
		this.addInvoiceLine(true)
		if (["proforma", "justinvoice"].includes(this.doctype)) {
			;(this.finresourceObj.total as any) =
				totalPaymentDetails == 0 ? "" : totalPaymentDetails
			this.updateVat()
			this.proformaTotal.focus(true)
		} else {
			this.sumAndVatInvoice()
		}
		if (this.finresourceObj.total != 0) {
			this.isFormSubmittable = true
		}
	}

	onDateChange() {
		if (this.invoice_per_followup) {
			return
		}
		this.store.dateFieldsInfluences(
			this.finresourceObj,
			"from_date",
			"to_date",
			this.toDate
		)
		this.finresourceObj.invoicelines = []
		let sendObj = {
			id: this.resourceId,
			from_date: this.finresourceObj.from_date,
			to_date: this.finresourceObj.to_date,
		}

		if (["patient", "payor"].includes(this.resource)) {
			if (this.payment_detailsWysiwyg) {
				this.payment_detailsWysiwyg.replaceText("")
			}

			this.detailsServerCall?.unsubscribe()

			const apiFunc =
				this.resource == "patient"
					? "get_patient_details_by_dates"
					: "get_payor_details_by_dates"

			console.log("here")

			this.detailsServerCall = this.apiService.postSubscribe(
				apiFunc,
				sendObj,
				this.postGetResourceByDates.bind(this)
			)
		} else {
			this.addInvoiceLine(true)
		}
	}

	updateTotals(res: any) {
		this.finresourceObj.total_lm_debt =
			res.totals_per_patient === undefined
				? res.total_lm_debt
				: res.totals_per_patient?.total_lm_debt
		this.finresourceObj.total_lm_prices =
			res.totals_per_patient === undefined
				? res.total_lm_prices
				: res.totals_per_patient?.total_lm_prices
		this.finresourceObj.total_until_lm_debt =
			res.totals_per_patient === undefined
				? res.total_until_lm_debt
				: res.totals_per_patient?.total_until_lm_debt
		this.finresourceObj.total_total_debt =
			res.totals_per_patient === undefined
				? res.total_total_debt
				: res.totals_per_patient?.total_total_debt

		// this.finresourceObj.total_lm_debt =  res.total_lm_debt;
		// this.finresourceObj.total_lm_prices = res.total_lm_prices;
		// this.finresourceObj.total_until_lm_debt =  res.total_until_lm_debt ;
		// this.finresourceObj.total_total_debt =  res.total_total_debt ;
	}

	chosePaymentApp(line: InvoiceLine) {
		const className = "transaction_id_" + line.hash
		let find = this.genInputs.find(
			(inp) => inp.className.indexOf(className) != -1
		)
		if (find) {
			find.focus(true)
		}
	}

	async focusLine(line: InvoiceLine) {
		await this.store.timeout()
		let className = ""

		switch (line.paymentmethod) {
			case "cheque":
				className = "cheque_num_" + line.hash
				break
			case "credit_card":
				className = "credit_card_4_digits_" + line.hash
				break
			case "paymentapp":
				className = "paymentapp_id_" + line.hash
				break
			default:
				className = "sum_" + line.hash
				break
		}
		if (className) {
			let find = this.genInputs.find(
				(inp) => inp.className.indexOf(className) != -1
			)
			if (find) {
				find.focus(true)
			} else {
				let find = this.genAutocompletes.find(
					(inp) => inp.className.indexOf(className) != -1
				)
				if (find) {
					find.focus(true)
				}
			}
		}
	}

	onChangePaymentmethod(line: InvoiceLine) {
		// line.value_date = "";
		// line.repayment_date = "";
		line.cheque_num = ""
		line.credit_card_4_digits = ""
		line.credit_card = 0
		line.credit_card_company = 0
		line.credittype = 0
		line.paymentapp_id = 0
		line.transaction_id = ""
		line.creditcard = null
		line.paymentapp = null
		line.bank_name = ""
		line.branch_name = ""

		if (["cheque", "bank_transfer"].includes(line.paymentmethod)) {
			if (this.bankaccounts.length) {
				line.account_num = this.bankaccounts[0].number
			}
		} else {
			line.account_num = 0
		}
		this.validateEntireForm()
		this.focusLine(line)
	}
	sumAndVatInvoice() {
		let totalSum = 0

		this.finresourceObj.invoicelines.forEach((line) => {
			totalSum += Number(line.sum) || 0
		})

		this.finresourceObj.total = totalSum
		this.updateVat()
		this.validateTotalAndFollowupsSumRules()
		// this.invoiceObj.vat=(Math.round(this.invoiceObj.vat*100))/100;
	}
	updateVat() {
		let totalSum = +this.finresourceObj.total
		if (this.doctype == "admininvoice") {
			let preVatSum = totalSum
			;(this.finresourceObj.vat as any) = (
				this.finresourceObj.withoutvat == "yes" || this.no_vat == "yes"
					? 0
					: (preVatSum * this.vat) / 100
			).toFixed(2)
			;(this.finresourceObj.totalMinusvat as any) =
				this.finresourceObj.withoutvat == "yes"
					? totalSum
					: preVatSum.toFixed(2)
			this.finresourceObj.total = +(
				totalSum + +this.finresourceObj.vat
			).toFixed(2)
		} else {
			let preVatSum = totalSum / (1 + this.vat / 100)
			;(this.finresourceObj.vat as any) = (
				this.finresourceObj.withoutvat == "yes" || this.no_vat == "yes"
					? 0
					: (preVatSum * this.vat) / 100
			).toFixed(2)
			;(this.finresourceObj.totalMinusvat as any) =
				this.finresourceObj.withoutvat == "yes" || this.no_vat == "yes"
					? totalSum
					: preVatSum.toFixed(2)
		}

		if (
			["invoice", "receipt"].includes(this.doctype) &&
			this.is_withholding_tax == "yes"
		) {
			const perc = +this.withholding_tax_percent || 0
			this.finresourceObj.withholding_tax_percent = perc
			this.finresourceObj.withholding_tax = (totalSum * perc) / 100
			this.finresourceObj.total_minus_withholding =
				totalSum - this.finresourceObj.withholding_tax
		}
		this.needsIta = this.getNeedsIta()
		if (this.needsIta) {
			this.has_id_number = true
		}
	}
	getNeedsIta() {
		const cc = this.store.cc()
		if (!cc?.ita_min) {
			return false
		}
		const isReceiptNgo = this.doctype === "receipt" && this.isNgo
		const isRightDoctype =
			["invoice", "justinvoice"].includes(this.doctype) || isReceiptNgo
		return isRightDoctype && cc.ita_min <= this.finresourceObj.totalMinusvat
	}
	getCurTopHash() {
		return this.finresourceObj.invoicelines.reduce(
			(acc, it) => Math.max(acc, it.hash),
			0
		)
	}

	addInvoiceLine(isFirstLine: boolean = false) {
		let newLine = new InvoiceLine()
		newLine.hash = this.getCurTopHash() + 1
		newLine.value_date = this.store.getToday()
		newLine.repayment_date = this.store.getToday()
		if (
			isFirstLine &&
			(this.show_payment_details == "yes" || this.invoice_per_followup)
		) {
			;(newLine as any).sum =
				this.finresourceObj.total != 0
					? this.store.only2Digits(this.finresourceObj.total)
					: ""
		} else {
			;(newLine as any).sum = ""
		}
		if (isFirstLine) {
			this.finresourceObj.invoicelines = []
		}
		this.finresourceObj.invoicelines = [
			...this.finresourceObj.invoicelines,
			newLine,
		]
		this.validateEntireForm()

		if (isFirstLine) {
			// this.focusLine(newLine);
			// window.scrollTo(100000, 100000);
		}
	}

	deleteLine(line: InvoiceLine) {
		this.finresourceObj.invoicelines = [
			...this.finresourceObj.invoicelines.filter((it) => it !== line),
		]
		this.validateEntireForm()
	}

	async openAddBankaccountModal(line: InvoiceLine) {
		this.curLine = line
		this.modalProps = { name: "add-bankaccount" }
	}
	handleAddBankaccountClose(obj: any = null) {
		if (obj) {
			if (this.curLine) {
				this.curLine.account_num = obj.number
			}
			this.getBankaccounts()
			this.validateEntireForm()
		}
		if (this.curLine) {
			this.focusLine(this.curLine)
		}
	}

	validateTotalAndFollowupsSumRules() {
		//if the sum of all invoicelines is GREATER than the checked followups prices sum (inc. credit) -
		//try to find an UNCHECKED followup whose price is less than this difference

		if (!this.finresourceObj.invoicelines?.length) {
			return
		}
		if (this.hasMissingFp()) {
			this.getFirstRow().errors.sum = this.lang.getVal(
				"please_include_the_followup_in_the_calculation"
			)
			this.isFormSubmittable = false
		}
		if (this.isDebtOnInvoice()) {
			this.getFirstRow().errors.sum = this.lang.getVal("no_debt_on_invoice")
			this.isFormSubmittable = false
		}
	}
	getFirstRow() {
		return this.finresourceObj.invoicelines[0]
	}
	hasMissingFp() {
		return this.followups.some(
			(followup) => followup.price <= this.getDiff() && !followup.checked
		)
	}
	isDebtOnInvoice() {
		return this.invoice_per_followup && this.getDiff() < 0
	}
	getDiff() {
		//total is sum of all invoicelines, followupsAndCreditSum is sum of all checked followups (minus credit)
		return (
			this.finresourceObj.total -
			this.followupsAndCreditSum -
			this.futureFusesSum
		)
	}
	handleHeadturesClose(headtureRow: any) {
		if (!headtureRow?.header_text) {
			this.previewObj = null
			return
		}
		this.previewObj = { ...this.previewObj, step: null, headtureRow }
		this.handleHeadtureRowSuccess()
	}
	handleGetHeadtureRow(headtureRow: any) {
		if (headtureRow?.header_text === null) {
			this.previewObj = { ...this.previewObj, step: "table-display-headtures" }
			return
		}
		this.handleHeadturesClose(headtureRow)
	}
	handleHeadtureRowSuccess() {
		if (this.store.cc().enable_israel_invoice === "yes" || !this.needsIta) {
			this.handleIsraelInvoiceConfirm(true)
			return
		}
		this.previewObj = { ...this.previewObj, step: "confirm-israel-invoice" }
	}
	handleIsraelInvoiceConfirm(approved: boolean) {
		if (!approved) {
			this.previewObj = null
			return
		}
		this.previewObj = { ...this.previewObj, step: null }

		if (
			!this.invoice_per_followup ||
			this.followupsAndCreditSum == this.finresourceObj.total
		) {
			this.handleTotalDiffApprove(true)
			return
		}
		this.previewObj = { ...this.previewObj, step: "confirm-total-diff" }
	}
	async handleTotalDiffApprove(approved: boolean) {
		if (!approved) {
			this.previewObj = null
			return
		}
		this.previewObj = { ...this.previewObj, step: null }

		console.log(this.previewObj)

		if (this.invoice_per_followup) {
			if (this.payment_for_future_meetings) {
				this.finresourceObj.futureFusIds = getCheckedIds(this.futureFuses)
			}

			const newCredit =
				this.finresourceObj.total -
				(this.followupsAndCreditSum + this.futureFusesSum)

			this.finresourceObj.followupsAndCreditSum = this.followupsAndCreditSum
			this.finresourceObj.includedFollowups = getChecked(this.followups).map(
				(it) => ({ id: it.id, is_group: it.is_group || 0 })
			)
			let html = ""
			html += `<table style="width:100%" class="invoice-payment-details">`
			html += "<thead>"
			html += `<tr style="line-height:100%;">`
			if (this.resource == "payor") {
				html += "<th>" + this.lang.getValHe("patient") + "</th>"
			}
			html += "<th>" + this.lang.getValHe("meetingtype") + "</th>"
			html += "<th>" + this.lang.getValHe("date") + "</th>"
			if (this.show_prices_withoutvat_in_finresource) {
				html += "<th>" + this.lang.getValHe("price_without_vat") + "</th>"
			}
			html += "<th>" + this.lang.getValHe("price") + "</th>"
			if (this.is_add_assoc) {
				html += "<th>" + this.lang.getValHe("therapist") + "</th>"
			}
			html += "</tr>"
			html += "</thead>"
			html += "<tbody>"
			getChecked(this.followups).forEach((followup, pos) => {
				html +=
					`<tr style="line-height:100%;` +
					(pos % 2 == 0 ? "background-color:#F5F5F5;" : "") +
					`" >`
				if (this.resource == "payor") {
					html += "<td>" + (followup?.patient_name || "") + "</td>"
				}
				html += "<td>" + followup.meetingtype_name + "</td>"
				html += "<td>" + dateDisplay(followup.date) + "</td>"
				if (this.show_prices_withoutvat_in_finresource) {
					html +=
						`<td class="display-number">` +
						this.store.numberFormat(followup.price_without_vat) +
						"</td>"
				}
				html +=
					`<td class="display-number">` +
					this.store.numberFormat(followup.price) +
					"</td>"
				if (this.is_add_assoc) {
					html += "<td>" + followup?.assoc + "</td>"
				}
				html += "</tr>"
			})
			getChecked(this.futureFuses).forEach((fus, pos) => {
				html +=
					`<tr style="line-height:100%;` +
					(pos % 2 == 0 ? "background-color:#F5F5F5;" : "") +
					`" >`
				if (this.resource == "payor") {
					html += "<td>" + (fus?.patient_name || "") + "</td>"
				}
				html += "<td>" + fus.meetingtype_name + "</td>"
				html += "<td>" + dateDisplay(fus.date) + "</td>"
				if (this.show_prices_withoutvat_in_finresource) {
					html +=
						`<td class="display-number">` +
						this.store.numberFormat(fus.price_without_vat) +
						"</td>"
				}
				html +=
					`<td class="display-number">` +
					this.store.numberFormat(fus.price) +
					"</td>"
				if (this.is_add_assoc) {
					html += "<td>" + fus?.assoc + "</td>"
				}
				html += "</tr>"
			})
			if (this.isCreditChecked && this.credit) {
				html += `<tr style="line-height:100%;">`
				if (this.show_prices_withoutvat_in_finresource) {
					html += `<td></td>`
				}
				html +=
					`<td colspan="` +
					(this.resource == "payor" ? 3 : 2) +
					`">` +
					(this.credit > 0
						? this.lang.getValHe("there_is_credit")
						: this.lang.getValHe("there_is_debt")) +
					"</td>"
				html +=
					`<td class="display-number">` +
					this.store.numberFormat(-this.credit) +
					"</td>"
				html += "</tr>"
			}
			if (newCredit != 0) {
				html += `<tr style="line-height:100%;">`
				html +=
					`<td colspan="` +
					(this.resource == "payor" ? 3 : 2) +
					`">` +
					(newCredit > 0
						? this.lang.getValHe("new_advance")
						: this.lang.getValHe("new_debt")) +
					"</td>"
				html +=
					`<td class="display-number">` +
					this.store.numberFormat(newCredit) +
					"</td>"
				html += "</tr>"
			}
			html += "</tbody>"
			html += "</table>"

			this.finresourceObj.payment_details = html
		}

		this.finresourceObj.invoicelines.forEach((il) => {
			if (il.credit_card) {
				il.creditcard = this.store
					.getSiteDataTable("creditcards")
					.find((it) => it.id == il.credit_card)
			}
			if (il.paymentapp_id) {
				il.paymentapp = this.store
					.getSiteDataTable("paymentapps")
					.find((it) => it.id == il.paymentapp_id)
			}
			if (Number(il.account_num)) {
				const bankAccount = this.bankaccounts.find(
					(it) => it.number == il.account_num
				)
				il.bank_name = bankAccount.bank_name
				il.branch_name = bankAccount.branch_name
			}
		})
		if (this.showPaymentDetailsButton == "no") {
			this.finresourceObj.payment_details = ""
		}
		const obj: any = { ...this.finresourceObj, id: this.previewObj.id }

		if (!this.has_id_number) {
			obj.id_number = ""
		}
		console.log(obj.payment_details)

		this.modalProps = {
			name: "preview-finresource",
			headtureRow: this.previewObj?.headtureRow || null,
			finresourceObj: obj,
		}
		this.previewObj = null
	}
	async handleId(id: any = null) {
		if (!id) {
			this.previewObj = null
			return
		}
		if (this.doctype === "admininvoice") {
			this.previewObj = { id }
			this.handleHeadtureRowSuccess()
			return
		}
		this.previewObj = {
			id,
			step: "headture",
		}
	}

	handlePreviewClose(retItem: any = null) {
		if (!retItem) {
			return
		}
		if (
			this.has_id_number &&
			this.finresourceObj.id_number &&
			retItem?.patient_id
		) {
			this.store.updatePatient({
				id: retItem.patient_id,
				id_number: this.finresourceObj.id_number,
			})
			this.store.personReloadSubj.next({
				personType: "patient",
				id: retItem.patient_id,
			})
			this.store.refreshTableSubject.next("patients")
			this.store.refreshTableSubject.next("payorpatients")
		}
		if (
			this.finresourceObj.bn_number &&
			(retItem.payor_id || retItem.contact_id)
		) {
			this.store.siteDataUpdateRow(`${this.resource}s`, {
				id: retItem[`${this.resource}_id`],
				bn_number: this.finresourceObj.bn_number,
			})
			this.store.personReloadSubj.next({
				personType: this.resource,
				id: retItem[`${this.resource}_id`],
			})
			this.store.refreshTableSubject.next("contacts")
			this.store.refreshTableSubject.next("payors")
		}

		this.onClose.emit(retItem)
	}

	numOnly(obj: any, fieldName: string, isOnChange = false) {
		obj[fieldName] = String(obj[fieldName]).trim().replace(/,/g, "")
		// if (fieldName == "sum" || fieldName == "total") {
		//is there minus?
		const pos = obj[fieldName].indexOf("-")
		if (pos != -1 && pos != 0) {
			obj[fieldName] = "-" + obj[fieldName].replace(/\-/g, "")
		}
		if (isOnChange) {
			this.sumAndVatInvoice()
		}
		this.validateEntireForm()
		this.validateTotalAndFollowupsSumRules()
	}

	getIdValidation() {
		if (this.resource !== "patient") {
			return null
		}
		if (this.needsIta) {
			return { id_number: { is_legit_fuzzy_value: true } }
		}
		if (this.has_id_number) {
			return { id_number: { is_legit_fuzzy_value_or_empty: true } }
		}
		return null
	}

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.errors = {}
		const exValidationObj = this.hasCurrentPlus && {
			current_plus: { is_zero_or_positive: true },
		}

		const bnValidationObj = ["payor", "contact"].includes(this.resource) &&
			this.needsIta && {
				bn_number: { is_legit_fuzzy_value: true },
			}
		const validationFields = {
			...this.validationFields[this.doctype],
			...exValidationObj,
			...this.getIdValidation(),
			...bnValidationObj,
		}
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.finresourceObj,
			this.errors,
			validationFields
		)
		if (["invoice", "receipt", "selfinvoice"].includes(this.doctype)) {
			if (!this.finresourceObj.invoicelines.length) {
				this.isFormSubmittable = false
				this.errors.noLines = this.lang.getVal("no_lines")
			}
			this.finresourceObj.invoicelines.forEach((line) => {
				line.errors = {}
				let validationRules = {}
				validationRules["sum"] = {
					not_empty: null,
					not_zero: null,
					is_decimal: null,
				}
				validationRules["value_date"] = { not_empty: null }
				switch (line.paymentmethod) {
					case "cheque":
						validationRules["account_num"] = { is_legit_fuzzy_value: null }
						validationRules["cheque_num"] = { not_empty: null, not_zero: null }
						break
					case "bank_transfer":
						break
					case "credit_card":
						validationRules["credit_card_4_digits"] = {
							not_empty: null,
							str_exact_length: 4,
						}
						validationRules["credit_card_company"] = {
							is_legit_fuzzy_value_or_empty: true,
						}
						validationRules["transaction_id"] = {}
						break
					case "paymentapp":
						validationRules["paymentapp_id"] = { is_legit_fuzzy_value: null }
						validationRules["transaction_id"] = {}
						break
				}
				let isLineValid = this.validator.validateEntireForm(
					line,
					line.errors,
					validationRules
				)
				if (!isLineValid) {
					this.isFormSubmittable = false
				}
			})
		} else if (["proforma", "justinvoice"].includes(this.doctype)) {
			if (this.isDebtOnInvoice()) {
				this.errors.total = this.lang.getVal("no_debt_on_invoice")
				this.isFormSubmittable = false
			}
		}
	}

	onChooseJustinvoice() {
		const justinvoiceObj = this.justinvoices.find(
			(it) => it.id == this.finresourceObj.justinvoice_id
		)
		const line = this.getFirstRow()
		if (justinvoiceObj && line) {
			line.sum = justinvoiceObj.total
			this.numOnly(line, "sum", true)
		}
	}
	onChooseReceipt() {
		const receiptObj = this.receipts.find(
			(it) => it.id == this.finresourceObj.receipt_id
		)
		if (receiptObj) {
			this.finresourceObj.total = receiptObj.total
			this.numOnly(this.finresourceObj, "total")
			this.updateVat()
			this.validateEntireForm()
		}
	}

	changeDoctype(newDocType: FinResourceType) {
		if (newDocType === "external_invoice") {
			this.handleUnsubscribe()
			return
		}
		const fields = [
			"inputRow",
			"description",
			"email_details",
			"paid_by",
			"for",
			"is_withholding_tax",
			"withholding_tax_percent",
			"defaultValues",
		]
		const obj = {}
		for (let field of fields) {
			obj[field] = this[field]
		}
		const { from_date, to_date } = this.finresourceObj
		this.reset()
		this.finresourceObj.from_date = from_date
		this.finresourceObj.to_date = to_date
		for (let field of fields) {
			this[field] = obj[field]
		}
		this.doctype = newDocType
		this.initLoad()
	}

	chPeriod() {
		//plant new dates
		let from: any = null
		switch (this.currentPeriod) {
			case "month_before":
				from = moment.utc().startOf("day").subtract(1, "month").startOf("month")
				this.finresourceObj.from_date = from.format(
					ConfigDefinitions.momentDateFormat
				)
				this.finresourceObj.to_date = moment
					.utc(from)
					.add(1, "month")
					.subtract(1, "day")
					.format(ConfigDefinitions.momentDateFormat)
				break
			case "this_month":
				from = moment.utc().startOf("day").startOf("month")
				this.finresourceObj.from_date = from.format(
					ConfigDefinitions.momentDateFormat
				)
				this.finresourceObj.to_date = moment
					.utc(from)
					.add(1, "month")
					.subtract(1, "day")
					.format(ConfigDefinitions.momentDateFormat)
				break
			case "this_week":
				from = moment.utc().startOf("day").startOf("week")
				this.finresourceObj.from_date = from.format(
					ConfigDefinitions.momentDateFormat
				)
				this.finresourceObj.to_date = moment
					.utc(from)
					.add(1, "week")
					.subtract(1, "day")
					.format(ConfigDefinitions.momentDateFormat)

				break
			case "today":
				from = moment.utc().startOf("day")
				this.finresourceObj.from_date = from.format(
					ConfigDefinitions.momentDateFormat
				)
				this.finresourceObj.to_date = from.format(
					ConfigDefinitions.momentDateFormat
				)
				break
			case "date_range":
				break
		}

		//api call
		this.fromDate.refreshWithModel()
		this.toDate.refreshWithModel()
		this.onDateChange()
	}
	checkAll(doCheck: boolean) {
		this.followupsAllChecked = doCheck
		this.followups.forEach((followup) => (followup.checked = doCheck))
		this.calcFollowupsAndCredit()
	}
	checkAllFutureFuses(doCheck: boolean) {
		this.futureFusesAllChecked = doCheck
		this.futureFuses.forEach((fus) => (fus.checked = doCheck))
		this.calcFutureFuses()

		// this.calcFollowupsAndCredit();
	}
	async createPrevDebtFus(prevDebt: any) {
		const today = moment.utc().format(ConfigDefinitions.momentDateFormat)
		const fus: any = {
			// assoc_sub_user_ids: this.permsService.owner_has_users?[]:[], //todo fill auth-user id
			assoc_sub_user_ids: [this.store.cc().user_id], //todo fill auth-user id
			change_series: "only_one",
			charged: "yes",
			contact_id: 0,
			current_original_date: "",
			current_original_date_to: "",
			followupserie_date: today,
			followupserie_date_to: today,
			followupserie_du_message: "",
			followupserie_du_remarks: "",
			followupserie_id: 0,
			followupserie_series_id: 0,
			followupserie_time: "07:00",
			followupserie_time_to: "07:20:00",
			followupserie_until_date: "",
			followuptype_id: 1,
			id: 0,
			invoice_id_patient: null,
			is_all_day: "no",
			is_assoc: "yes", // this is the default
			is_create_overlap_exceptions: "no",
			is_group: "no",
			is_new_patient_or_contact: "no",
			length: 20,
			location_id: this.permsService?.owner_has_users
				? this.store.getSiteDataTable("locations")[0]?.id || 0
				: 0,
			meeting_on_holiday: "no",
			meeting_request_id: 0,
			meeting_title: "",
			meeting_with: "patient",
			meetingtype_id: -1,
			mode: "add",
			name: "",
			new_phone_input: "",
			new_phone_input2: "",
			notes: "",
			notification_default: "sms",
			notifiy: "no",
			patient_id: this.resourceId,
			patient_name: "",
			payor_id: 0,
			price: prevDebt,
			repeat_days: 0,
			ser_id: 0,
			series_limit_date: "",
			series_repeat: "one_time",
			start_day: moment.utc().day(),
			takes_place: "no",
			tarif_id: this.permsService?.owner_has_users
				? this.store.getSiteDataTable("tarifs")[0]?.id || 0
				: 0,
			time: "",
			time_to: "",
			user_id: 0,
			vacation_all_users: "no",
		}

		const res: any = await this.apiService.post("prepare_for_save", fus)
		if (!res) {
			return
		}

		if (fus.patient_id) {
			this.store.detectMixedListChangeNeeded("followups", fus.patient_id)
		}

		if (res.add) {
			this.store.addFus(res.add)
		}

		if (res.followups) {
			this.store.overrideRecentFollowups(res.followups)
		}
		this.isFinanciallyNew = false
		this.getFollowupsAndCreditForFinResource()
	}

	chooseProforma() {
		if (!this.invoice_per_followup) {
			return
		}
		const proforma = this.proformas.find(
			(it) => it.id == this.finresourceObj.proforma_id
		)
		if (!proforma?.followups_data) {
			return
		}
		const followups_data = JSON.parse(proforma.followups_data)
		if (!followups_data?.includedFollowups?.length) {
			return
		}
		const ids = followups_data.includedFollowups.map((it) => it.id)
		this.checkAll(false)
		this.followups.forEach((fp) => {
			if (ids.includes(fp.id)) {
				this.followupCheck(fp, true)
			}
		})
	}
	chooseProformaIds(proformas: any[] = []) {
		this.finresourceObj.proforma_ids = proformas.map((it) => it.id)
		if (!this.invoice_per_followup) {
			return
		}
		this.checkAll(false)
		proformas.forEach((p) => {
			const id = p.id
			const proforma = this.proformas.find((it) => it.id == id)
			if (!proforma?.followups_data) {
				return
			}
			const followups_data = JSON.parse(proforma.followups_data)
			if (!followups_data?.includedFollowups?.length) {
				return
			}
			const ids = followups_data.includedFollowups.map((it) => it.id)
			this.followups.forEach((fp) => {
				if (ids.includes(fp.id)) {
					this.followupCheck(fp, true)
				}
			})
		})
		if (!this.finresourceObj.total && proformas.length) {
			const line = this.getFirstRow()
			if (line) {
				line.sum = sumByProp(proformas, "total")
				this.numOnly(line, "sum", true)
			}
			this.finresourceObj.description = proformas.at(0).description
			this.validateEntireForm()
		}
	}
	chooseJustinvoiceIds(jusinvoices: any[] = []) {
		this.checkAll(false)
		this.finresourceObj.justinvoice_ids = jusinvoices.map((it) => it.id)
	}
	chooseReceiptIds(receipts: any[] = []) {
		this.finresourceObj.receipt_ids = receipts.map((it) => it.id)
	}
}

//Q: account - on open of modal, what's going on, is this ready for use?
//Q: credit fuzzies - need to design, maybe wider modal?
//-proforma should be seen - proformas of payor using list_proformas_ajax (payor_id or patient_id)
//-invoice_withoutvat_yes btn-group? yes (default is yes)
//-withholding_tax ? leave for now
//-when is trash for line? always
//-how do we deal with bank account options? list in db of "bankaccounts" for this payor/patient/contact, the "plus" opens modal to add one (gen of "bankaccounts")
//show-bankaccount_patient_list? nothing for now
//-credit company vs credit? company vs card name

//come back to "debt details" (payment details)
